module.exports = __webpack_public_path__ + "static/media/menu_close.62cd9b58.svg";